import React, { useContext } from 'react';
import { Optional, Box, Column, Row } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';

import NoticeSection from './NoticeSection';
import { VinContext } from '../../contexts/VinContext';
import SupportCTA from './SupportCTA';
import themeStyles from './styles/NoticeGrid.styles';
import pushGtmCtaClickEvent from '../../utils/gtm/pushGtmCtaClickEvent';
import { gtmCtaTypes } from '../../utils/gtm/gtmTags';
import NoticeGridPropTypes from './INoticeGrid';
import useSharedApps from '../../hooks/useSharedApps';
import useConfiguration from '../../hooks/useConfiguration';
import componentConfig from './componentConfig';
import { DEALER_LOCATOR_URL, campaignStatus } from '../../utils/constants';

const Container = themeStyles.apply(Box, 'Container');
const GridContainer = themeStyles.apply(Row, 'GridContainer');
const LinkRow = themeStyles.apply(Row, 'LinkRow');

const NoticeGrid = ({ campaignSections, contactCTA, serviceCTA, status }) => {
  const scheduleMaintenanceUrl = useSharedApps(DEALER_LOCATOR_URL);
  const vin = useContext(VinContext);
  const { t } = useTranslation();

  // TODO QuickLink icon color can be set in DSR
  const {
    iconColor: contactCTAIconColor,
    hasContactClientAnchor,
    showEngineContactUsLabel,
    showScheduleMaintenance,
  } = useConfiguration(componentConfig);

  if (!campaignSections || !campaignSections.length) {
    return null;
  }

  return (
    <Container width={[1, 10 / 12]} isThisOutstandingNotices={status === campaignStatus.ongoing}>
      <GridContainer>
        {campaignSections.map(section => (
          <Row key={section?.title}>
            <NoticeSection campaignSection={section} />
          </Row>
        ))}
        <Optional when={status === campaignStatus.ongoing}>
          <LinkRow>
            <Optional when={showScheduleMaintenance}>
              <Column width={[1, serviceCTA ? 1 / 2 : 1]}>
                <SupportCTA
                  title={serviceCTA?.label}
                  variantName="tertiary"
                  href={scheduleMaintenanceUrl}
                  ariaLabel={serviceCTA?.ariaLabel}
                  iconName="calendar"
                  iconSize="large"
                  testId="cy-schedule-support"
                  target="_blank"
                  gtmEventHandler={() => pushGtmCtaClickEvent(vin, gtmCtaTypes.scheduleServiceCTA)}
                />
              </Column>
            </Optional>

            <Column width={[1, showScheduleMaintenance ? 1 / 2 : 1]}>
              <SupportCTA
                title={showEngineContactUsLabel ? t('Sub-apps.Recalls.contactUsButton') : contactCTA?.label}
                href={hasContactClientAnchor ? '#contact-client-services' : contactCTA?.url}
                variantName={showScheduleMaintenance ? 'primary' : 'tertiary'}
                ariaLabel={contactCTA?.ariaLabel}
                iconName="contact"
                iconColor={contactCTAIconColor}
                testId="cy-contact-support"
                gtmEventHandler={() => pushGtmCtaClickEvent(vin, gtmCtaTypes.contactUsCTA)}
                target={hasContactClientAnchor ? undefined : '_blank'}
              />
            </Column>
          </LinkRow>
        </Optional>
      </GridContainer>
    </Container>
  );
};

NoticeGrid.propTypes = NoticeGridPropTypes;

export default NoticeGrid;
